import { api } from "@/lib/api";

/**
 * The signed-in workspace's demo data generation (demo deployments only). The
 * page remembers which generation it loaded against (ADP-271); nothing about
 * it is shown to the user.
 */
export interface DemoWorkspace {
  workspaceId: string;
  generation: { completedAt: string | null } | null;
}

export const DEMO_WORKSPACE_QUERY_KEY = ["demo", "workspace"] as const;

export async function fetchDemoWorkspace(): Promise<DemoWorkspace> {
  const response = await api.get("demo/workspace").json<{ success: true; data: DemoWorkspace }>();
  return response.data;
}
